import React from "react";
import "./AdventureTrip.css";
import MountainTrekkingExpedition from "../../assets/MountainTrekkingExpedition.png";
import RiverRaftingAdventure from "../../assets/RiverRaftingAdventure.png";
import DesertSafariExperience from "../../assets/DesertSafariExperience.png";
import ScubaDivingJourney from "../../assets/ScubaDivingJourney.png";
import ForestCampingRetreat from "../../assets/ForestCampingRetreat.png";
import SkydivingThrill from "../../assets/SkydivingThrill.png";
import { useNavigate } from "react-router-dom";
const adventureTrips = [
  {
    title: "Mountain Trekking Expedition",
    image: MountainTrekkingExpedition,
    description:
      "Challenge yourself with an exciting mountain trekking expedition through scenic trails and breathtaking landscapes. Experience fresh air, stunning sunrise views, and thrilling climbs. Perfect for adventure lovers seeking endurance, exploration, and unforgettable outdoor memories.",
    link: "/tour-package-data",
  },
  {
    title: "River Rafting Adventure",
    image: RiverRaftingAdventure,
    description:
      "Feel the adrenaline rush while navigating powerful river rapids with your team. Enjoy splashing waters, scenic valleys, and exciting challenges along the way. A thrilling experience designed for adventure seekers who love action.",
    link: "/tour-package-data",
  },
  {
    title: "Desert Safari Experience",
    image: DesertSafariExperience,
    description:
      "Explore vast golden dunes with an exhilarating desert safari ride. Enjoy dune bashing, camel rides, and cultural evening entertainment under starry skies. A perfect adventure blending thrill, tradition, and unforgettable landscapes.",
    link: "/tour-package-data",
  },
  {
    title: "Scuba Diving Journey",
    image: ScubaDivingJourney,
    description:
      "Dive into crystal clear waters and discover vibrant marine life beneath the ocean surface. Experience colorful coral reefs, underwater exploration, and peaceful aquatic surroundings. An exciting adventure for those seeking unique underwater thrills.",
    link: "/tour-package-data",
  },
  {
    title: "Forest Camping Retreat",
    image: ForestCampingRetreat,
    description:
      "Reconnect with nature through an adventurous forest camping experience. Enjoy hiking trails, campfire nights, and wildlife spotting in peaceful surroundings. Ideal for explorers looking to escape city life and embrace outdoor adventure.",
    link: "/tour-package-data",
  },
  {
    title: "Skydiving Thrill",
    image: SkydivingThrill,
    description:
      "Experience the ultimate adrenaline rush with a breathtaking skydiving adventure. Feel the excitement of freefall while enjoying panoramic aerial views. A once in a lifetime experience designed for bold adventurers.",
    link: "/tour-package-data",
  },
];

const AdventureTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="adventure-container">
      <h2 className="adventure-title">Adventure Trip Packages</h2>

      <div className="adventure-grid">
        {adventureTrips.map((trip, index) => (
          <div
            className="adventure-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="adventure-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdventureTrip;
